"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSwitch = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = require("./style");
const util_1 = require("../util");
const __1 = require("..");
/** Hidden input */
const Input = styled_components_1.default.input `
  display: none;
`;
const Label = styled_components_1.default.label `
  cursor: inherit;
`;
const ActiveLabel = styled_components_1.default.span `
  position: absolute;
  left: 0;
  width: ${({ count }) => `${99 / count}%`};
  height: 100%;
  border-radius: 5px;
  outline: ${({ theme }) => theme.multiSwitch.outline.selected};
  box-shadow:
    inset 0 1px 2px #fff3,
    ${({ theme }) => "0 0 0 1px " + theme.highlight};
  border-bottom: ${({ theme }) => theme.multiSwitch.bottomBorder};
  background: ${({ theme }) => theme.multiSwitch.background.selected};
  @media (prefers-reduced-motion: no-preference) {
    transition: left 0.3s linear;
  }
`;
const MultiSwitchButton = styled_components_1.default.div `
  padding: ${({ theme }) => theme.spacing};
  cursor: pointer;
  display: flex;
  align-content: center;
  justify-content: center;
  &:focus {
    border-radius: ${({ theme }) => theme.radius};
  }
`;
const MultiSwitch = ({ options, selected, callback, minWidth = "10ex", disabled, onFocus, onBlur, label, height, padding, }) => {
    var _a;
    const [isChecked, setIsChecked] = react_1.default.useState(false);
    const [currentSelectedOption, setCurrentSelectedOption] = react_1.default.useState(selected || ((_a = options[0]) === null || _a === void 0 ? void 0 : _a.value));
    react_1.default.useEffect(() => {
        if (currentSelectedOption !== selected) {
            setCurrentSelectedOption(selected);
        }
    }, [selected, currentSelectedOption]);
    const buttonsRef = (0, react_1.useRef)([]);
    const containerRef = (0, react_1.useRef)(null);
    // This set of options should have a unique name
    label = label || (0, util_1.uniqueID)();
    react_1.default.useEffect(() => {
        if (options.length > 0 &&
            !options.some((option) => option.value === currentSelectedOption)) {
            setCurrentSelectedOption(options[0].value);
        }
    }, [currentSelectedOption, options]);
    react_1.default.useEffect(() => {
        const handleKeyDown = (event) => {
            var _a, _b, _c, _d;
            if ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) {
                const focusedButtonIndex = buttonsRef.current.findIndex((button) => button === document.activeElement);
                if (event.key === "Tab") {
                    if (event.shiftKey && focusedButtonIndex > 0) {
                        // If Shift + Tab is pressed and the focused option is not the first one
                        event.preventDefault();
                        const prevButtonIndex = focusedButtonIndex - 1;
                        (_b = buttonsRef.current[prevButtonIndex]) === null || _b === void 0 ? void 0 : _b.focus();
                    }
                    else if (!event.shiftKey &&
                        focusedButtonIndex < buttonsRef.current.length - 1) {
                        // If Tab is pressed and the focused option is not the last one
                        event.preventDefault();
                        const nextButtonIndex = focusedButtonIndex + 1;
                        (_c = buttonsRef.current[nextButtonIndex]) === null || _c === void 0 ? void 0 : _c.focus();
                    }
                }
                else if (event.key === " " || event.key === "Enter") {
                    (_d = buttonsRef.current[focusedButtonIndex]) === null || _d === void 0 ? void 0 : _d.click();
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return (react_1.default.createElement(style_1.Container, { ref: containerRef, "data-testid": "multiswitch", count: options.length, disabled: disabled, height: height },
        options.map((option, index) => {
            const isSelected = option.value === currentSelectedOption;
            const optionId = `${label}:${option.value}`;
            return (react_1.default.createElement(MultiSwitchButton, { key: option.value.toString(), ref: (ref) => (buttonsRef.current[index] = ref), style: {
                    ...{
                        opacity: isSelected ? 1 : 0.6,
                        zIndex: 4,
                        height: height !== null && height !== void 0 ? height : "40px",
                        padding: padding !== null && padding !== void 0 ? padding : "11px 10px 9px",
                        minWidth,
                        borderRight: index !== options.length - 1 ? "1px solid #0003" : "none",
                    },
                    ...(option.disabled
                        ? {
                            opacity: 0.3,
                            background: "#222",
                            cursor: "default",
                        }
                        : {}),
                }, onFocus: () => onFocus && onFocus(label), onBlur: () => onBlur && onBlur(), onClick: (event) => {
                    if (!disabled && !option.disabled) {
                        setCurrentSelectedOption(option.value);
                        callback(option.value, event);
                    }
                }, tabIndex: 0 },
                react_1.default.createElement("div", { style: { overflow: "hidden" } },
                    react_1.default.createElement(Input, { type: "radio", id: optionId, name: label, checked: isSelected, onChange: () => setIsChecked(!isChecked), disabled: !!option.disabled }),
                    react_1.default.createElement(Label, { htmlFor: optionId },
                        react_1.default.createElement(__1.TooltipOnOverflow, { title: option.title }, option.label ? option.label : option.value)))));
        }),
        react_1.default.createElement(ActiveLabel, { style: {
                left: `${(options.findIndex((option) => option.value === currentSelectedOption) * 100) / options.length}%`,
            }, count: options.length })));
};
exports.MultiSwitch = MultiSwitch;
//# sourceMappingURL=index.js.map